import CONST from "./Constant";
import { stripProtocol } from "../../../../Setup/Utility/urlUtils";

const INITIAL_STATE = {
    selected: {},
    url: null,
    isLoading: false,
    partialResult: null,
    requiresOTP: false,
    otp: {
        sent: false,
        error: null
    },
    error: []
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case CONST.ANALYZE_SUCCESS:
            const payload = action.payload;
            const responseData = payload?.data || payload;
            const isPartial = responseData?.partial === true;
            const resultUrl = responseData?.url || state.url;
            const normalizedResultUrl = resultUrl ? stripProtocol(resultUrl) : null;

            return {
                ...state,
                selected: responseData,
                url: normalizedResultUrl || resultUrl,
                isLoading: false,
                error: [],
                requiresOTP: isPartial,
                partialResult: isPartial ? responseData : null
            };

        case CONST.ANALYZE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: [action.payload]
            };

        case CONST.SEND_OTP_SUCCESS:
            return {
                ...state,
                otp: {
                    ...state.otp,
                    sent: true,
                    error: null
                }
            };

        case CONST.CLEAR_OTP:
            return {
                ...state,
                otp: {
                    sent: false,
                    error: null,
                    email: null
                }
            };

        case CONST.SEND_OTP_FAILURE:
            const sendOTPError = action.payload?.data?.message || action.payload?.data?.error || action.payload?.message || action.payload?.error || 'Failed to send OTP. Please try again.';
            return {
                ...state,
                otp: {
                    ...state.otp,
                    error: typeof sendOTPError === 'string' ? sendOTPError : 'Failed to send OTP. Please try again.'
                }
            };

        case CONST.VERIFY_OTP_SUCCESS:
            const verifyResponseData = action.payload.data || action.payload;
            const verifyResultUrl = verifyResponseData.url || state.url;
            const normalizedVerifyUrl = verifyResultUrl ? stripProtocol(verifyResultUrl) : null;

            return {
                ...state,
                selected: verifyResponseData || state.selected,
                url: normalizedVerifyUrl || verifyResultUrl || state.url,
                requiresOTP: false,
                partialResult: null,
                otp: {
                    ...state.otp,
                    error: null
                }
            };

        case CONST.VERIFY_OTP_FAILURE:
            const verifyOTPError = action.payload?.data?.message || action.payload?.data?.error || action.payload?.message || action.payload?.error || 'Invalid OTP. Please try again.';
            return {
                ...state,
                otp: {
                    ...state.otp,
                    error: typeof verifyOTPError === 'string' ? verifyOTPError : 'Invalid OTP. Please try again.'
                }
            };

        case CONST.SET_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };

        case CONST.CLEAR_RESULT:
            return {
                ...state,
                selected: {},
                url: null,
                partialResult: null,
                requiresOTP: false,
                error: [],
                isLoading: false
            };

        default:
            return state;
    }
}

export default Reducer;